export const departmentContacts = [
	{
		department: "Sales",
		email: "sales@zroh.com",
		forwardingTo: ["sales@zroh.com", "sales@zroh.com"],
	},
	{
		department: "Feed India (Sales Department)",
		email: "feedindia.jcipl@japfa.com",
		forwardingTo: ["yogesh.shah@japfa.com", "subhadra.tripati@japfa.com"],
	},
	{
		department: "Farm India (CGF Department)",
		email: "farmdindia.jcipl@japfa.com",
		forwardingTo: ["yogesh.shilimkar@japfa.com"],
	},
	{
		department: "Food India (Food Department)",
		email: "fooddindia.jcipl@japfa.com",
		forwardingTo: ["dhiraj.choudhary@japfa.com"],
	},
	{
		department: "Finance India (Finance Department)",
		email: "financeindia.jcipl@japfa.com",
		forwardingTo: [
			"manoj.sonalkar@japfa.com",
			"deepak.bhutada@japfa.com",
			"nilesh.wadekar@japfa.com",
			"sital.paria@japfa.com",
		],
	},
	{
		department: "Procurement India (Procurement Department)",
		email: "procurementindia.jcipl@japfa.com",
		forwardingTo: [
			"mahesh.naik@japfa.com",
			"nigam.mishra@japfa.com",
			"vinod.patil@japfa.com",
		],
	},
	{
		department: "Quality India (Quality Department)",
		email: "qualityindia.jcipl@japfa.com",
		forwardingTo: ["manish.patil@japfa.com", "qcsupa.jcipl@japfa.com"],
	},
	{
		department: "Animal health India (Animal health Department)",
		email: "animalhealthindia.jcipl@japfa.com",
		forwardingTo: ["sunil.sawant@japfa.com", "anuja.dhurpate@japfa.com"],
	},
	{
		department: "Hr India (HR Department)",
		email: "hrd.jcipl@japfa.com",
		forwardingTo: ["abhay.adhav@japfa.com", "santosh.kokane@japfa.com"],
	},
];
